import { CustomDateValueT, PredefinedDateValueT } from '@mulesoft/anypoint-components/lib/DatePicker';
import { isUndefined } from 'util';
import * as moment from 'moment'

class DateType {
  static  isCustomDate(date: PredefinedDateValueT | CustomDateValueT ): date is CustomDateValueT {
    return  !(<PredefinedDateValueT> date).amount
  }

  static formatTime(date: Date): string {
    return `${DateType.checkPrefixedZero(date.getHours())}:` +
      `${DateType.checkPrefixedZero(date.getMinutes())}:` +
      `${DateType.checkPrefixedZero(date.getSeconds())}`
  }

  static formatDate(date: Date): string {
    const parsedDate = new Date(date);
    const month = date.getMonth() + 1;
    parsedDate.setHours(0);
    parsedDate.setMinutes(0);
    parsedDate.setSeconds(0);
    return `${parsedDate.getFullYear()}` +
        `-${DateType.checkPrefixedZero(month)}-${DateType.checkPrefixedZero(parsedDate.getUTCDate())}`
  }

  static checkPrefixedZero(i: number) {
    return (i < 10) ? '0' + i : i;
  }

  static  mappingDateT(from: string, to: string, options: any[]): PredefinedDateValueT | CustomDateValueT {
    return DateType.isDate(from) || DateType.isDate(to) ?
        DateType.customDate(from, to) : DateType.predefinedDate(from, options)
  }

  static isDate(date: string) {
    return !isNaN(Date.parse(date))
  }

  static customDate(from: string, to: string): CustomDateValueT {
    const fromDate = new Date(from);
    const toDate = new Date(to);

    return {
      range: [DateType.formatDate(fromDate), DateType.formatDate(toDate)],
      startTime: DateType.formatTime(fromDate),
      endTime: DateType.formatTime(toDate)
    }
  }

  static predefinedDate(from: string, options: any[]): PredefinedDateValueT {
    return {
      amount: +from.replace(/\D+/g, ''),
      format: DateType.getTimeMapping(from.charAt(from.length - 1), 'graph', options).mule
    }
  }

  static getTimeMapping(value: string, target: string, options: any[]) {
    const timeMapping = options.find(time => time[target] === value);
    return isUndefined(timeMapping) ? options[0] : timeMapping
  }

  static formatMoment(moment: moment.Moment): string {
    const date: Date = moment.local().toDate()
    return `${DateType.formatDate(date)} ${DateType.formatTime(date)}`
  }

  static formatVisualizerTime(time: any) {
    if (moment.isMoment(time)) {
      return DateType.formatMoment(time)
    } else {
      return time
    }
  }

}

export default DateType
